var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReserveOnline = function SvgReserveOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.827 20.577 12.02 28.75l-8.815-9.204 9.679-10.144A6.113 6.113 0 0 1 17.292 7.5c1.653 0 3.238.684 4.408 1.902a6.542 6.542 0 0 1 1.506 2.539",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 16.907a2.922 2.922 0 1 1 1.924-3.517",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.847 15.289a4.376 4.376 0 0 1-.307-.336l-.11-.132a5.285 5.285 0 0 1-1.135-3.286M19.456 7.722c.572-.56 1.27-.98 2.039-1.226a5.218 5.218 0 0 1 2.383-.185 5.18 5.18 0 0 1 2.21.896 5.06 5.06 0 0 1 1.555 1.782 4.958 4.958 0 0 1 .012 4.564 5.058 5.058 0 0 1-1.546 1.79 5.178 5.178 0 0 1-2.205.907",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.727 21.25a4.045 4.045 0 0 1-.37-.246 4.385 4.385 0 0 1-.62-.548 4.762 4.762 0 0 1-1.197-2.386 4.944 4.944 0 0 1 .25-2.693 4.61 4.61 0 0 1 1.61-2.092 4.186 4.186 0 0 1 2.431-.785c.865 0 1.711.273 2.43.785a4.61 4.61 0 0 1 1.612 2.092c.331.851.418 1.788.25 2.693a4.762 4.762 0 0 1-1.198 2.386c-.294.312-.627.58-.99.794",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.706 21.25v11.31L23.416 35l-2.71-2.44v-2.087l1.865-1.811-1.865-1.067 2.086-2.05-2.086-.83.004-3.465M9.456 18.75v2.5h5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.706 30.602a11.672 11.672 0 0 1-5-5.602M21.956 9.649a11.648 11.648 0 0 1 4.502-.899h.183c.239 0 .478 0 .713.03a11.757 11.757 0 0 1 7.875 3.95 11.934 11.934 0 0 1 2.968 8.343 11.92 11.92 0 0 1-3.59 8.092 11.742 11.742 0 0 1-8.149 3.335",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.956 16.25h-5V30M31.956 20h6.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReserveOnline;